export default class HttpStatus {

    constructor(response) {
        this.response = response
    }

    disconnected() {
        return !(this.response)
    }

    internalError() {
        return this.response.status === 500
    }

    serviceUnavailable() {
        return this.response.status === 503
    }

    unauthorized() {
        return this.response.status === 401
    }

    forbidden() {
        return this.response.status === 403
    }

    notFound() {
        return this.response.status === 404
    }

    unprocessableEntity() { return this.response.status === 422 }

}
